"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapEvenRolesToRoles = exports.matchToRoleType = exports.mapRolesToEvenRoles = void 0;
const tslib_1 = require("tslib");
const capitalize_1 = tslib_1.__importDefault(require("lodash/capitalize"));
const snakeCase_1 = tslib_1.__importDefault(require("lodash/snakeCase"));
const words_1 = tslib_1.__importDefault(require("lodash/words"));
const api_models_1 = require("@portal/api-models");
const mapRolesToEvenRoles = (roles = []) => roles.map((role) => `portal_${(0, snakeCase_1.default)(role)}`);
exports.mapRolesToEvenRoles = mapRolesToEvenRoles;
const matchToRoleType = (role) => {
    const roleKeys = Object.keys(api_models_1.Roles);
    const key = roleKeys.find((k) => {
        const val = api_models_1.Roles[k].toLowerCase();
        if (role.toLowerCase() === val) {
            return true;
        }
        return false;
    });
    const found = api_models_1.Roles[key];
    return found || role.split(' ').map(capitalize_1.default).join(' ');
};
exports.matchToRoleType = matchToRoleType;
const mapEvenRolesToRoles = (roles = []) => {
    return roles
        .filter((r) => r.includes('portal_'))
        .map((role) => (0, words_1.default)(role.replace('portal_', '')).join(' '))
        .map(exports.matchToRoleType)
        .sort();
};
exports.mapEvenRolesToRoles = mapEvenRolesToRoles;
